export default "__VITE_ASSET__BaNWdkbI__"